import type { PropsWithChildren } from 'react';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../meta';

export function Deactivation({
  children,
  ...forwardingProps
}: PropsWithChildren) {
  const { displayDeactivation, deactivationURL } = useSettings();

  return (
    <Deactivation2
      {...forwardingProps}
      appAlias={meta.alias}
      displayDeactivation={displayDeactivation}
      deactivationURL={deactivationURL}
    >
      {children}
    </Deactivation2>
  );
}
